<template>

  <ContentsPageTitleV2 capital="SEE HOW OUR PRODUCTS ARE USED IM YOUR APPLICATIONS" title="Use Case"
                       description="Under the hood and Powertrain"/>
  <CardUserCase :contents="UnderTheHoodAndPowertrain"/>


</template>

<script setup>
import CardUserCase from '~/components/contents/CardUserCase.vue'

useHead({
  title: 'Under the hood Powertrain - NAGASE THAILAND Engineering Plastics',
})
const UnderTheHoodAndPowertrain = [
  {
    "pdf": true,
    "img": "/pages/products/use-cases/sab.jpg",
    "title": "SABIC® PP UMS en Foamed Air Duct",
    "to": "/pages/products/use-cases/SABICPP-UMS-en-FoamedAirDuct.pdf"
  },
  {
    "pdf": true,
    "img": "/pages/products/use-cases/b01.jpg",
    "title": "Thermoplastic Solutions for Automotive Oil Pumps",
    "to": "/pages/products/use-cases/ThermoplasticSolutionsforAutomotiveOilPumps.pdf"
  }

]
</script>
